<template>
  <hel-module title="主要供应商" :class="scope.clsPrefix">
    <div class="supplier-container">
      <div class="supplier-header">
        <span class="col-name">供应商名称</span>
        <span class="col-amount">金额(万元)</span>
      </div>
      <div class="supplier-list">
        <div
          class="supplier-row"
          v-for="(item, index) in supplierList"
          :key="index"
        >
          <span class="col-name" :title="item.name">{{ item.name }}</span>
          <span class="col-amount">{{ formatAmount(item.amount) }}</span>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from './common/module/index.vue'
import axios from 'axios'

export default {
  name: 'MainSuppliers',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-main-suppliers'
      },
      supplierList: []
    }
  },
  mounted() {
    this.fetchMainSuppliers()
  },
  methods: {
    formatAmount(val) {
      // 接口金额单位为元，统一换算为万元展示：保留两位小数 + 千分位
      const num = Number(val) / 10000
      return num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      })
    },
    async fetchMainSuppliers() {
      try {
        const response = await axios.post(
          'https://bigdata-cloud.cosmoplat.com/prod-api/system/api/call/erp/mainSuppliers',
          {
            secret: '9k0NVP'
          },
          {
            headers: {
              'Content-Type': 'application/json'
            }
          }
        )

        console.log('主要供应商接口返回:', response.data)

        if (
          response.data.code === 200 &&
          Array.isArray(response.data.data)
        ) {
          // 字段映射层：统一映射为组件使用的字段
          this.supplierList = response.data.data.map((item) => ({
            name: item.supplierName,
            amount: item.amount
          }))
        }
      } catch (error) {
        console.error('获取主要供应商数据失败:', error)
      }
    }
  }
}
</script>

<style lang="scss">
$class-prefix: "rvc-cosmoplat-workspace-main-suppliers";
.#{$class-prefix} {
  .supplier-container {
    // height: 100%;
    height: calc(100% - 40px);
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .supplier-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: #f7f8fc;
    border-radius: 4px;
    flex-shrink: 0;
    .col-name {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
    .col-amount {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 12px;
      color: #333333;
    }
  }
  .supplier-list {
    flex: 1;
    overflow-y: auto;
    margin-top: 4px;
    // 纤细滚动条：透明轨道 + 浅灰圆角滑块，hover 加深
    scrollbar-width: thin;
    scrollbar-color: #d0d3d9 transparent;
    &::-webkit-scrollbar {
      width: 6px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    &::-webkit-scrollbar-thumb {
      background: #d0d3d9;
      border-radius: 3px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #b6bac4;
    }
  }
  .supplier-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 12px;
    &:hover {
      background: #f7f8fc;
    }
    .col-name {
      flex: 1;
      margin-right: 12px;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .col-amount {
      flex-shrink: 0;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      font-size: 12px;
      color: #333333;
    }
  }
}
</style>
